import { useState } from 'react';
import { Button } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';

const AGENCY_LIST = ['ALI', 'CHANG', 'STEP', 'RAMIREZ', 'HAJAR', 'EUNICE', 'helena', 'FERNANDA', 'BMD_KOR'];

const AgencyInput = () => {
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.AgencyInput;
  const [agencyName, setAgencyName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleConfirm = async () => {
    if (!agencyName.trim()) {
      setErrorMessage('Invalid Code');
      return;
    }

    const trimmedAgency = agencyName.trim();
    const matchedAgency = AGENCY_LIST.find((agency) => agency.toUpperCase() === trimmedAgency.toUpperCase());

    if (!matchedAgency) {
      setErrorMessage('Invalid Code');
      return;
    }

    setIsLoading(true);
    setErrorMessage('');

    try {
      const success = await PrimeDataManager.registerBJ(myinfo.fbUid, matchedAgency);

      if (success) {
        close(sheet.id, { data: { success: true, agency: matchedAgency } });
      } else {
        setErrorMessage('Invalid Code');
        setIsLoading(false);
      }
    } catch (err) {
      console.error('[AgencyInput] Failed to register BJ:', err);
      setErrorMessage('Failed to register BJ. Please contact customer service if the problem persists.');
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-full w-full flex-col gap-16 pt-8">
      <div className="flex w-full flex-col gap-4">
        <div className="typography-title-lg text-dialog-txt-default">Code</div>
        <input
          type="text"
          value={agencyName}
          onChange={(e) => {
            setAgencyName(e.target.value);
          }}
          placeholder="Please enter the code"
          className=" placeholder:text-input-txt-placeholder typography-body-lg w-full rounded-lg border-2 border-transparent bg-input-bg-default px-[var(--spacing-lg)] py-[var(--spacing-xl)] text-input-txt-default focus:border-base-border-focus focus:outline-none"
          disabled={isLoading}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isLoading && agencyName.trim()) {
              handleConfirm();
            }
          }}
        />
      </div>

      <div className="flex w-full flex-col items-center gap-4">
        <div className="typography-body-sm flex min-h-[48px] w-full items-end justify-center text-red-500">{errorMessage}</div>
        <Button
          onClick={isLoading || !agencyName.trim() ? undefined : handleConfirm}
          style={{
            text: 'Confirm',
            color: isLoading || !agencyName.trim() ? 'btn-bg-disabled' : 'btn-bg-primary',
            fontColor: isLoading || !agencyName.trim() ? 'btn-txt-disabled' : 'btn-txt-primary',
            borderRadius: 'full',
          }}
          className={`w-full px-[var(--spacing-2xl)] py-[var(--spacing-xl)]`}
        />
      </div>
    </div>
  );
};

export default AgencyInput;
